import { render, staticRenderFns, recyclableRender, components } from "./recharge.vue?vue&type=template&id=0ac6895c&scoped=true&"
var renderjs
import script from "./recharge.vue?vue&type=script&lang=js&"
export * from "./recharge.vue?vue&type=script&lang=js&"
import style0 from "./recharge.vue?vue&type=style&index=0&id=0ac6895c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac6895c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/account/recharge.vue"
export default component.exports